import React, { useState, useEffect, useRef, useContext } from "react";
import "./Subsidy_Banner.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { Speaker_Lottie } from "../../common/lotties/speaker-lottie/Speaker_Lottie";
import {
  SubsidyBanners,
  LatestAnnouncements,
} from "../../../utils/apis/subsidy-policy/SubsidyPolicy";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const Subsidy_Banner = () => {
  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    const res = await SubsidyBanners();

    if (res?.success) {
      setBanner(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  const [latestannouncement, setLatestAnnouncement] = useState([]);

  const getLatestAnnouncement = async () => {
    const res = await LatestAnnouncements();

    console.log("LatestAnnouncement data", res);

    if (res?.success) {
      setLatestAnnouncement(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getLatestAnnouncement();
  }, []);

  return (
    <section className="Subsidy_Banner">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-9 col-md-9">
            <div className="Subsidy_Banner_holder">
              {banner.map((item) => (
                <div className="row">
                  <div className="col-lg-8 col-md-7">
                    <div className="banner_content_holder">
                      <h5 className="Subsidy_Banner_title">
                        <span> {item.title}</span>
                      </h5>

                      <p className="Subsidy_Banner_content">
                        <span>{htmlToReactParser.parse(item.description)}</span>
                      </p>

                      <h5 className="modi_name">- {item.name}</h5>
                      <p className="modi_desg">{item.position}</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-5">
                    <div className="modi_img_holder">
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        alt="modi"
                        className="modi_img"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-3 col-md-3">
            <div className="Subsidy_right_Banner_holder">
            {latestannouncement.map((val) => (
              <>
              <div className="banner_lottie_holder">
                {/* <img src="/assets/images/subsidy/speaker.png" /> */}

                <Speaker_Lottie />
              </div>

              <h5 className="announcment">Latest Announcement</h5>
              
                <p className="right_content">
                  {/* Currently, uploading the warranty document is optional while
                submitting installation details on the National Portal vendor
                login. It will soon be mandatory, so vendors should ensure
                consumer wise warranty documents are available. */}
                  {htmlToReactParser.parse(val.description)}
                </p>
              

              <div className="download_btn_holder">
                <a
                  href={IDS?.IMG_URL + val?.pdf}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Common_Btn text={"Download PDF"} />
                </a>
              </div>
              </>
            ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subsidy_Banner;
